import React from 'react';
import { DefaultLayout } from 'src/layouts';
import { initStore } from 'src/store';
import withRedux from 'next-redux-wrapper';
import { showModal, closeModal, showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';
import { setAlert } from 'src/modules/shared/alert/actions';
import { trackFootfallEvent, trackFootfallEventWithHrefDelay, trackEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

import WithSession from 'src/components/hoc/withSession';

import Section from 'src/modules/home/components/section';
import FeatureList from 'src/modules/home/components/featureList';
import DiscoverSection from 'src/modules/home/components/discoverSection';
import UserQuotesSection from 'src/modules/home/components/userQuotesSection';
import SearchSection from 'src/modules/home/components/searchSection';
import Last30DaysSection from 'src/modules/home/components/last30daysSection';
import PAMModal from 'src/modules/home/components/PAMmodal';
import SiteBar from 'src/components/siteBar/siteBar';
import { fetchNumbers } from 'src/modules/home/actions';
import stylesheet from 'styles/pageContent/home.scss';
import i18n from 'i18next';
import config from 'config/config';

class IndexPage extends React.Component {
  static async getInitialProps({ store: { dispatch } }) {
    await dispatch(fetchNumbers());
    return {};
  }

  componentDidMount() {
    trackEvent('Section', 'Home page');
  }

  onSubmitEmail = (e, refName) => {
    e.preventDefault();
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickMetadata: { section: 'join' },
      clickType: 'visitor-homepage',
    });
    this.props.showSignupModal({}, null, false, this[refName].value);
  };

  render() {
    const { lang } = this.props;
    const seo = {
      canonical: 'https://healthunlocked.com',
      ogTitle: 'HealthUnlocked is the Social Network for Health',
      description: 'Are you looking for answers to your health concerns?\nThere are others who’ve been there before.\n\n#UnlockYourHealth',
      image: `${config.CDN_PATH}/betelgeuse/img/Facebook-share-post_4.png`,
    };
    return (
      <DefaultLayout
        fullWidth={true}
        lang={lang}
        seo={seo}
        siteBar={<SiteBar isHome={true} lang={lang} />}
        siteContainerClassName="site-container home"
      >
        <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
        <Section withColumns={true}>
          <div>
            <h1>{i18n.t('Connect with others who understand')}</h1>
            <p>{i18n.t('No one should face health challenges alone.')}</p>
            <p>
              {i18n.t(
                "Whether you're managing a serious condition, working on improving your wellbeing or caring for a loved one; our network can help you.",
              )}
            </p>
            <p>{i18n.t('Join and get support anonymously.')}</p>
            <form onSubmit={e => this.onSubmitEmail(e, 'emailRef')}>
              <input
                className="form-control home__form-input--small"
                placeholder={i18n.t('email@address.com')}
                ref={node => (this.emailRef = node)}
                type="text"
              />
              <button className="btn btn-primary btn-lg" type="submit">
                {i18n.t('Join')}
              </button>
            </form>
            <p>
              {i18n.t('Already a member?')}{' '}
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  this.props.showLoginModal();
                }}
              >
                {i18n.t('Log in')}
              </a>
            </p>
          </div>
          <div className="home__section-side">
            <img alt="Home" className="home__image hidden-xs"
              src={`${config.cdn.static}img/home/home-1-desktop.jpg`} />
            <img alt="Home" className="home__image visible-xs"
              src={`${config.cdn.static}img/home/home-1-mobile.jpg`} />
          </div>
        </Section>
        <UserQuotesSection />
        <Section>
          <h2>{i18n.t('Take control of your health')}</h2>
          <p>
            {i18n.t('Get information, support and tools that have been shown to improve health outcomes.')}{' '}
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickMetadata: { section: 'see-research' },
                  clickType: 'visitor-homepage',
                });
                this.props.showModal(<PAMModal />);
              }}
            >
              {i18n.t('Learn about our research')}
            </a>
          </p>
          <FeatureList />
        </Section>
        <SearchSection />
        <Section className="home__partners">
          <h2>{i18n.t('Our partners')}</h2>
          <p>
            {i18n.t(
              "Over 600 organizations have used our technology to build health communities. It's the best available and it's free to nonprofits, health advocates, and patient organizations.",
            )}{' '}
            <a
              href="/start"
              onClick={e => {
                e.preventDefault();
                trackFootfallEventWithHrefDelay('/start', footfallEventTypes.CLICKED, {
                  clickMetadata: { section: 'partners-learnmore' },
                  clickType: 'visitor-homepage',
                });
              }}
            >
              {i18n.t('Start a community')} <span className="icon icon-forwards-arrow" />
            </a>
          </p>
          <p>
            <img
              alt="Partner logos"
              className="visible-xs"
              src={`${config.cdn.static}img/home/partner-logos-mobile.png`}
            />
            <img alt="Partner logos" className="hidden-xs"
              src={`${config.cdn.static}img/home/partner-logos.png`} />
          </p>
        </Section>
        <Last30DaysSection />
        <DiscoverSection />
        <Section withColumns={true}>
          <h2 className="home__input-title">{i18n.t('Join today. For free, forever.')}</h2>
          <form className="home__long-form" onSubmit={e => this.onSubmitEmail(e, 'emailJoinRef')}>
            <input
              className="form-control home__form-input"
              placeholder={i18n.t('email@address.com')}
              ref={node => (this.emailJoinRef = node)}
              type="text"
            />
            <button className="btn btn-primary btn-lg" type="submit">
              {i18n.t('Join')}
            </button>
          </form>
        </Section>
      </DefaultLayout>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.context.currentUser,
  };
};

const actions = {
  showModal,
  closeModal,
  setAlert,
  showSignupModal,
  showLoginModal,
};

export default withRedux(initStore, mapStateToProps, actions)(WithSession(IndexPage));



// WEBPACK FOOTER //
// ./pages/index.js